export const LICENSE_TYPE = {
    free_this_month: 'Free until end of the month',
    billable_this_month: 'Billable this month',
};

export const SUBSCRIPTIONS = {
    standard: 'Standard',
    advanced: 'Advanced',
};

export const AGREE_TEXT =
    'I acknowledge that adding or changing licensed users will ' +
    'change my invoice amounts';

export const AGREE_HELP = 'I acknowledge that adding or changing...';

export const AGREE_FIELDS = ['subscription_level', 'seats'];

export const ORGANIZATION_TYPES = {
    msp: {
        customer: 'Customer',
    },
};

export const isCustomerType = type => type === 'customer';

export const MAX_SMALL_INTEGER = 32767;
export const NAME_MAX_LENGTH = 150;
